import React from 'react';
export const PAYMENTS_INFO = {
    header: <h2>Credits history</h2>,
    body: (
        <>
            <p>Available for only the global admin role</p>
        </>
    ),
};
